












































































































































































































































import { AmazonEBaySetupClass } from "@/components/setup/AmazonEBaySetupClass";
import { OnlineMbePackTypeDef } from "@/model/component.model";
import { OnlineMbePackTypeDto } from "@/model/data.model";
import { CustomerService } from "@/services/CustomerService";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { PriceListService } from "@/services/PriceListService";
import { required } from "vuelidate/lib/validators";
import { ShipmentService } from "@/services/ShipmentService";
import Modal from "@components/shared/modal/Modal.vue";

const MacroAreaNames = {
  National: "NATIONAL",
  Transborder: "TRANSBORDER",
  Worldwide: "WORLDWIDE"
};

const ShipmentTypes = {
  Domestic: "DOMESTIC",
  Import: "IMPORT",
  Export: "EXPORT"
};

const ECommerceName = {
  Ebay: "EBAY",
  Amazon: "AMAZON"
};

@Component({
  components: {
    MbeModal: Modal
  },
  validations() {
    return {
      amazonEbaySetup: {
        mbePackageType: { required }
      }
    };
  }
})
export default class AmazonEBaySetup extends Vue {
  packageWeightDimensions = [
    {
      title: "default_package_weight",
      label: "shipment_package_customerWeight",
      value: "weight",
      weight: 0,
      min: 0,
      max: 100
    },
    {
      title: "default_package_dimensions",
      label: "setupecomm_shipment_package_length",
      value: "length",
      length: 0,
      min: 0,
      max: 200
    },
    {
      label: "setupecomm_shipment_package_width",
      value: "width",
      width: 0,
      min: 0,
      max: 200
    },
    {
      label: "setupecomm_shipment_package_height",
      value: "height",
      height: 0,
      min: 0,
      max: 200
    }
  ];
  amazonEbaySetup: AmazonEBaySetupClass = null;
  mbeServices = [];
  readyMbeServices = false;
  amazonLinkModalVisible = false;
  amazonLinkProcessing = false;
  amazonLinkError = false;
  amazonLinkProgress = 0;
  amazonLinkSellerCode = "";
  amazonLinkToken = "";

  created() {
    this.createdFunction();
  }

  createdFunction() {
    const ecommerceName = this.$route.params.type.toUpperCase();
    const tenantId = this.$store.getters["customer/info"].tenantId;
    const customerId = this.$store.getters["customer/info"].customerId;
    const username = this.$store.getters.user.username;
    const data = {
      ecommerceName,
      tenantId,
      customerId,
      username
    };
    this.amazonEbaySetup = new AmazonEBaySetupClass(data);
    if (this.amazonEbaySetup.ecommerceName === "AMAZON") {
      const { state, selling_partner_id, spapi_oauth_code } = this.$route.query;
      if (state && selling_partner_id && spapi_oauth_code) {
        this.amazonLinkProcessing = true;
        this.amazonLinkError = false;
        this.amazonLinkProgress = 0;
        this.amazonLinkModalVisible = true;
        ShipmentService.refreshAmazonToken(
          state as string,
          selling_partner_id as string,
          spapi_oauth_code as string
        )
          .then((res: any) => {
            this.amazonLinkSellerCode = selling_partner_id as string;
            this.amazonLinkToken = res.refresh_token;
          })
          .catch(() => (this.amazonLinkError = true))
          .finally(() => {
            this.amazonLinkProcessing = false;
            this.amazonLinkProgress = 100;
          });
      }
    }
    this.loadPackageTypes()
      .then(() => this.loadDefaultEcommerceServices())
      .then(() => this.loadMBECourierVisibility())
      .then(() => this.getCustomerMbeServices())
      .then(() => this.getCustomerOrderConfiguration());
  }

  save() {
    const customerOrderConfigurationPayload = this.amazonEbaySetup.getEcommerceOrderConfigurationPayload(
      this.packageWeightDimensions
    );
    const customerMbeServicePayload = this.amazonEbaySetup.getEcommerceMbeServicesPayload();
    CustomerService.saveCustomerECommerceOrderConfiguration(
      customerOrderConfigurationPayload
    )
      .then(() => {
        return CustomerService.saveCustomerECommerceMbeServices(
          this.amazonEbaySetup.ecommerceName,
          customerMbeServicePayload
        );
      })
      .then(() => {
        this.$snotify.success(
          this.$t(
            `${this.amazonEbaySetup.ecommerceName.toLowerCase()}_saved`
          ).toString()
        );
      });
  }

  saveAmazonLink() {
    this.amazonEbaySetup.amazonSellerCode = this.amazonLinkSellerCode;
    this.amazonEbaySetup.token = this.amazonLinkToken;
    this.save();
    this.closeAmazonLinkModal();
  }

  closeAmazonLinkModal() {
    this.amazonLinkModalVisible = false;
    this.$router.push(this.$route.path);
  }

  beforeRouteUpdate(to, from, next) {
    next();
    this.createdFunction();
  }

  loadMBECourierVisibility() {
    return CustomerService.getOnlineMBECourierVisibility(this.$store)
      .then(res => {
        this.mbeServices = res.filter(
          (item: any) => item.courierServiceId === 0
        );
        return PriceListService.getMbeServices();
      })
      .then(response => {
        this.amazonEbaySetup.exportServices = response.filter(item =>
          this.mbeServices
            .filter(visible => visible.mbeServiceId === item.idMBEService)
            .find(el => el.shipmentType === ShipmentTypes.Export)
        );
        this.amazonEbaySetup.domesticServices = response.filter(item =>
          this.mbeServices
            .filter(visible => visible.mbeServiceId === item.idMBEService)
            .find(el => el.shipmentType === ShipmentTypes.Domestic)
        );
      });
  }

  loadDefaultEcommerceServices() {
    return CustomerService.getEcommerceServices(
      this.amazonEbaySetup.ecommerceName
    ).then(res => {
      this.amazonEbaySetup.customerEcommerceMbeServices = res.map(item =>
        Object.assign({}, item, {
          ecommerceCourierServiceName: `${item.ecommerceCourierServiceName}_${item.macroareaId}`
        })
      );
    });
  }

  loadPackageTypes() {
    return CustomerService.getCustomerPackTypes().then(res => {
      this.amazonEbaySetup.mbePackageTypes = res.map(
        (item: OnlineMbePackTypeDto) => {
          const translatedMbePackageType = {
            ...item
          } as OnlineMbePackTypeDef;
          translatedMbePackageType.translatedPackTypeDescription = this.$t(
            "mbePackageType_" + item.packtypeBusinessId
          ).toString();
          return translatedMbePackageType;
        }
      );
      this.amazonEbaySetup.mbePackageType =
        this.amazonEbaySetup.mbePackageTypes.length > 0
          ? this.amazonEbaySetup.mbePackageTypes[0]
          : null;
    });
  }

  getCustomerMbeServices() {
    return CustomerService.getCustomerECommerceMbeServices(
      this.amazonEbaySetup.ecommerceName
    ).then(res => {
      if (res.length > 0) {
        this.amazonEbaySetup.customerEcommerceMbeServices.forEach(item => {
          const customerService = res.find(
            customer =>
              customer.ecommerceCourierServiceName ===
              item.ecommerceCourierServiceName
          );
          if (customerService) {
            item.idOrderMbeService = customerService.idOrderMbeService;
            if (item.macroareaName === MacroAreaNames.National) {
              item.value =
                this.amazonEbaySetup.domesticServices.find(
                  service =>
                    service.idMBEBusiness ===
                    customerService.mbeServiceBusinessId
                ) || null;
            } else {
              item.value =
                this.amazonEbaySetup.exportServices.find(
                  service =>
                    service.idMBEBusiness ===
                    customerService.mbeServiceBusinessId
                ) || null;
            }
          }
        });
      }
      this.readyMbeServices = true;
    });
  }

  getCustomerOrderConfiguration() {
    return CustomerService.getCustomerECommerceOrderConfiguration(
      this.amazonEbaySetup.ecommerceName
    ).then(res => {
      if (res) {
        this.amazonEbaySetup.customerEcommerceOrderConfiguration = res;
        const map = {
          weight: "defaultPackageWeight",
          length: "defaultDepth",
          height: "defaultHeight",
          width: "defaultWidth"
        };
        Object.keys(map).forEach(key => {
          this.packageWeightDimensions.find(item => item.value === key)[key] =
            res[map[key]];
        });
        this.amazonEbaySetup.mbePackageType = this.amazonEbaySetup.mbePackageTypes.find(
          item => item.packTypeDescription === res.defaultPackTypeName
        );
        this.amazonEbaySetup.token = res.token;
        this.amazonEbaySetup.amazonSellerCode = res.sellerId;
        this.amazonEbaySetup.expireDate = res.expireDate
          ? new Date(res.expireDate)
          : null;
      }
    });
  }

  getServices(macroareaName: string) {
    return macroareaName === MacroAreaNames.National
      ? this.amazonEbaySetup.domesticServices
      : this.amazonEbaySetup.exportServices;
  }

  changeMbeService(index: number, value: any) {
    this.$set(
      this.amazonEbaySetup.customerEcommerceMbeServices,
      index,
      Object.assign(this.amazonEbaySetup.customerEcommerceMbeServices[index], {
        value
      })
    );
  }

  async onStartECommerceSession() {
    const ecommerceName = this.amazonEbaySetup.ecommerceName;
    const customerId = this.amazonEbaySetup.customerId;
    const username = this.amazonEbaySetup.username;

    const errorMessage = this.$i18n.t("ecommerce_token_error", {
      ecommerceName: ecommerceName
    });

    if (ECommerceName.Ebay === ecommerceName) {
      try {
        const response = await CustomerService.prototype.getSessionEbayId(
          customerId,
          username
        );
        if (!(await this.$alerts.confirm(this.$t("ebay_confirm_redirect")))) {
          return;
        }
        const currentUrl = response.url;
        const currentSessionId = response.sessionId;
        this._openECommerceLogin(currentUrl, ecommerceName);
        if (await this.$alerts.confirm(this.$t("ebay_confirm_terms"))) {
          this.amazonEbaySetup.token = await CustomerService.prototype.getEbayToken(
            customerId,
            username,
            currentSessionId
          );
        }
      } catch (_) {
        this.$snotify.error(String(errorMessage));
      }
    } else if (ECommerceName.Amazon === ecommerceName) {
      if (!(await this.$alerts.confirm(this.$t("amazon_confirm_redirect")))) {
        return;
      }
      const rand = Math.random()
        .toString(36)
        .substr(2, 8);
      const amazonUrl = `https://sellercentral.amazon.com/apps/authorize/consent?application_id=amzn1.sp.solution.036f4811-8284-40c2-ab63-5f06eeb4874f&state=${rand}&version=beta`;
      this._openECommerceLogin(amazonUrl, ecommerceName);
    }
  }

  oauthProva() {
    console.log("prova");
  }

  get amazonLinkStatus() {
    if (this.amazonLinkProgress === 100) {
      if (!this.amazonLinkError) {
        return "green";
      } else {
        return "red";
      }
    }
    return "orange";
  }

  private _openECommerceLogin(url: string, target: string) {
    if (ECommerceName.Amazon === target) {
      document.location.replace(url);
    } else {
      window.open(url, target);
    }
  }
}
